// extracted by mini-css-extract-plugin
export default {"Wrapper":"_Wrapper--KD1ki","Terminate":"_Terminate--DYe4T","Delete":"_Delete--znK_S","RemoveButton":"_RemoveButton--WiMQb"};